import { Box, Flex, HStack, IconButton, Text, VStack } from '@chakra-ui/react';
import {
  MdCheckCircle,
  MdCancel,
  MdSchedule,
  MdMailOutline,
  MdMarkEmailRead,
  MdPhone,
} from 'react-icons/md';
import { FiCopy, FiEdit, FiTrash2 } from 'react-icons/fi';
import { Handle, Position } from 'reactflow';

const TRACKING_LABELS = {
  read:      { action: 'Read',          notAction: 'No Read',      icon: MdMarkEmailRead, header: 'Message Read'     },
  delivered: { action: 'Delivered',     notAction: 'Not Delivered', icon: MdMailOutline,  header: 'Message Delivered' },
  answered:  { action: 'Call Answered', notAction: 'Not Answered',  icon: MdPhone,        header: 'Call Answered'    },
};

export const MessageReadNode = ({ data }) => {
  const waitTime = data.waitTime || 24;
  const waitUnit = data.waitUnit || 'hours';
  const trackingMode = data.trackingMode || 'read';
  const labels = TRACKING_LABELS[trackingMode] || TRACKING_LABELS.read;
  const HeaderIcon = labels.icon;

  return (
    <Box
      borderWidth="2px"
      borderColor={data.selected ? '#00bc7d' : 'gray.300'}
      borderRadius="xl"
      bg="white"
      boxShadow={data.selected ? 'xl' : 'lg'}
      minW="250px"
    >
      <Handle type="target" position={Position.Left} style={{ background: 'black' }} />

      <Flex
        bgGradient="linear(to-r, #009966, #00bc7d)"
        color="white"
        px={4}
        py={2.5}
        borderTopRadius="xl"
        align="center"
        gap={2}
      >
        <HeaderIcon size={16} />
        <Text noOfLines={1} flex={1} fontSize="sm" fontWeight="medium">
           Message Delivery Status
          {/* {labels.header}
           */}
        </Text>
        <HStack spacing={1}>
          <IconButton
            icon={<FiEdit size={14} />}
            size="xs"
            variant="ghost"
            color="white"
            onClick={(e) => { e.stopPropagation(); data.onEdit?.(data.id); }}
          />
          <IconButton
            icon={<FiCopy size={14} />}
            size="xs"
            variant="ghost"
            color="white"
            onClick={(e) => { e.stopPropagation(); data.onDuplicate?.(data.id); }}
          />
          <IconButton
            icon={<FiTrash2 size={14} />}
            size="xs"
            variant="ghost"
            color="white"
            onClick={(e) => { e.stopPropagation(); data.onDelete?.(data.id); }}
          />
        </HStack>
      </Flex>

      <VStack p={3} align="stretch" spacing={3}>
        <Text fontSize="sm" fontWeight="medium">
          {data.label || labels.header}
        </Text>
        <Flex align="center" gap={2} fontSize="xs" color="gray.600">
          <MdSchedule size={14} />
          <Text>Wait: {waitTime} {waitUnit}</Text>
        </Flex>
        <VStack spacing={2} align="stretch">
          <Flex align="center" gap={2}>
            <MdCheckCircle size={16} color="green" />
            <Text fontSize="xs">{labels.action}</Text>
            <Handle
              type="source"
              position={Position.Right}
              id="yes"
              style={{
                width: 8,
                height: 8,
                background: '#22c55e',
                border: '2px solid white',
                top: '60%'
              }}
            />
          </Flex>
          <Flex align="center" gap={2}>
            <MdCancel size={16} color="red" />
            <Text fontSize="xs">{labels.notAction}</Text>
            <Handle
              type="source"
              position={Position.Right}
              id="no"
              style={{
                width: 8,
                height: 8,
                background: '#ef4444',
                border: '2px solid white',
                top: '80%'
              }}
            />
          </Flex>
        </VStack>
      </VStack>
    </Box>
  );
};